import { InMemoryCache } from 'apollo-cache-inmemory/lib/inMemoryCache'
import gql from 'graphql-tag'
import get from 'lodash-es/get'

export const keywordDefaults = {
  Keyword: {
    __typename: 'Keyword',
    editing: false,
    expanded: false,
  }
}

export const keywordResolvers = {
  Keyword: {
    editing: (obj, args, { cache }) => {
      const id = `Keyword:${obj.id}`
      const fragment = gql`
        fragment editing on Keyword { editing }
      `
      const keyword = cache.readFragment({ fragment, id })
      return get(keyword, 'editing', false)
    },
    expanded: (obj, args, { cache }) => {
      const id = `Keyword:${obj.id}`
      const fragment = gql`
        fragment expanded on Keyword { expanded }
      `
      const keyword = cache.readFragment({ fragment, id })
      return get(keyword, 'expanded', false)
    }
  }
}

export const keywordMutations = {
  ToggleKeywordExpandedMutation: (_, args: { id: number, expanded: boolean }, ctx: { cache: InMemoryCache }) => {
    ctx.cache.writeData({ id: `Keyword:${args.id}`, data: { expanded: args.expanded } })
    return null
  },
  ToggleKeywordEditingMutation: (_, args: { id: number, editing: boolean }, ctx: { cache: InMemoryCache }) => {
    ctx.cache.writeData({ id: `Keyword:${args.id}`, data: { editing: args.editing } })
    return null
  }
}
